import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import styled from 'styled-components'
import { Table, TableCell, TableHeader, Button as OriginalButton, ContextMenu, Pagination, Modal, TableLoading, TextIcon } from 'advenio-components'
import { connect } from 'react-redux'
import moment from 'moment'
import queryString from 'query-string'
import { push } from 'react-router-redux'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ProfileHeader from '../../ProfileHeader'
import AddDepositModal from './AddDepositModal'
import ConfirmDeleteChargeModal from './ConfirmDeleteChargeModal'
import CompanyAccountActions from '@redux/CompanyAccountRedux'
import { formatDecimalNumber } from 'utils/Utils.js'

const Container = styled.div`
  padding: 8px;
`
const Button = styled(OriginalButton)`
  font-size: 16px;
`
const AddDepositButton = styled(Button)``
const TableContainer = styled.div`
  margin: 8px;
`
const CompanyAccountContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`
const Info = styled.div`
  width: 97%;
  height: 50px;
  display: flex;
  justify-content: left;
  align-items: center;
`
const Description = styled.div`
  display: flex;
  flex-direction: column;
`
const Span = styled.span`
  ${({ blue }) => {
    if (blue) {
      return `
        color: #4A90E2;
      `
    }

    return 'margin-right: 5px'
  }};
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 78px;

  .file-to-download {
    cursor: pointer;
    max-height: 30px;

    &:first-child{
      margin-right: 20px;
    }
  }`

const PaginationContainer = styled.div`
  width: 50%;
  padding: 32px 0;
`

class CompanyAccount extends Component {
  state = {
    addDepositOpen: false,
    chargeId: null,
    subtotal: 0,
    isMexican: false,
    discount: null,
    pageSelected: 1,
    typeToDelete: 'pago',
    isConfirmDeleteChargeModalOpen: false,
  }
  componentWillMount = () => {
    const queryParams = queryString.parse(this.props.location.search)
    const { getCompanyAccount, company: { id } } = this.props
    if (queryParams.page) {
      this.setState({ pageSelected: parseInt(queryParams.page) })
    }
    getCompanyAccount(id, this.state.pageSelected)
  }

  componentWillReceiveProps = (nextProps) => {
    const { balance, isDeleting } = nextProps

    if (this.props.balance && this.props.balance.payments !== balance.payments && !isDeleting) {
      this.closeDeleteChargeModal()
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { goTo, getCompanyAccount, company: { id } } = this.props

      getCompanyAccount(id, page)
      goTo(`?page=${page}`)
    })
  }

  renderInvoice = invoices => (
    <div>
      {invoices.map(invoice => (
        <span key={invoice.id}>{invoice.invoice_number} <br /> </span>
      ))}
    </div>
  )

  toggleDeposit = () => this.setState({ addDepositOpen: !this.state.addDepositOpen })

  closeDeposit = () => this.setState({ addDepositOpen: false })

  confirmDeleteCharge = (id, type) => {
    this.setState({
      typeToDelete: type,
      chargeId: id,
      isConfirmDeleteChargeModalOpen: true,
    })
  }

  closeDeleteChargeModal = () => this.setState({ isConfirmDeleteChargeModalOpen: false })

  generatePrice = (value, country) => {
    if (!value && value !== 0) {
      return ''
    }

    return (
      <div>
        <span>{`${country.currency_symbol} ${formatDecimalNumber(value)}`}</span>
      </div>
    )
  }

  handleDelete = (id) => {
    if (this.state.typeToDelete === 'cargo') {
      this.props.deleteCharge(id)
    } else {
      this.props.deletePayment(id)
    }
  }
  paymentType = method => this.props.paymentTypes.filter(p => p.type.id === method)[0].type.name

  render() {
    const {
      loading,
      createPayment,
      balance,
      sending,
      company,
      country,
      paymentTypes,
      isDeleting,
      meta,
    } = this.props
    const { pageSelected, chargeId, isConfirmDeleteChargeModalOpen, typeToDelete } = this.state
    return (
      <Container>
        <ProfileHeader
          header="Estado de Cuenta"
          noSave
          buttons={[
            <AddDepositButton
              primary
              key="deposit"
              onClick={this.toggleDeposit}
              disabled={loading}
            >
              <TextIcon iconType="plus" label="Deposito" iconViewBox="-2 -2 24 24" />
            </AddDepositButton>,
          ]}
        />
        {(balance && balance.formatted_balance) &&
        <CompanyAccountContainer>
          <Info>
            <Span>Saldo actual: </Span>
            <Span blue>{`${balance.formatted_balance}`}</Span>
          </Info>
          {/* <Info>
            <Span>Total a pagar antes del corte: </Span>
            <Span blue>{`${balance.formatted_monthly_debt}`}</Span>
          </Info> */}
        </CompanyAccountContainer>
        }
        <PaginationContainer>
          <Pagination
            totalElements={meta && meta.total}
            elementsPerPage={meta && meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>
        {loading ? (
          <TableLoading
            curvedTop
            columns={[
              {
                id: 1,
                header: 'Fecha',
                element: 'Text',
                center: true,

              },
              {
                id: 2,
                header: 'Concepto',
                element: 'Text',
                center: true,
              },
              {
                id: 3,
                header: 'Facturas vinculadas',
                element: 'Text',
                center: true,
              },
              {
                id: 4,
                header: 'Pago',
                element: 'Text',
                center: true,
              },
            ]}
            rows={10}
          />
        ) : (
          <TableContainer>
            <Table
              roundedCorners
              data={balance && balance.payments}
              columns={[
                {
                  Header: () => <TableHeader title="Fecha" blue center />,
                  accessor: 'created_at',
                  Cell: ({ value: created_at }) => (
                    <TableCell center noEllipsis>
                      {moment(created_at).format('DD MMM YY')}
                    </TableCell>
                  ),
                },
                {
                  id: 'description',
                  Header: () => <TableHeader title="Concepto" blue />,
                  accessor: ({ method_id }) =>
                    ({ method_id }),
                  Cell: ({ value: { method_id } }) => (
                    <TableCell noEllipsis>
                      <Description>
                        <div>
                          Deposito - ({this.paymentType(method_id)})
                        </div>
                        <div>
                          {/* {this.getDiscount(discount)} */}
                        </div>
                      </Description>
                    </TableCell>
                  ),
                },
                {
                  id: 'invoice_id',
                  Header: () => <TableHeader title="Facturas vinculadas" center blue noEllipsis />,
                  accessor: ({ invoice_conciled }) => ({ invoice_conciled }),
                  Cell: ({ value: { invoice_conciled } }) => (
                    <TableCell center noEllipsis>{invoice_conciled !== undefined ? this.renderInvoice(invoice_conciled) : null}</TableCell>
                  ),
                },
                {
                  id: 'payment',
                  Header: () => <TableHeader title="Pago" blue noEllipsis />,
                  accessor: 'amount',
                  maxWidth: 250,
                  Cell: ({ value: amount }) => (
                    <TableCell noEllipsis>{this.generatePrice(amount, country)}</TableCell>
                  ),
                },
                {
                  id: 'accions',
                  Header: () => <TableHeader title="" center blue />,
                  accessor: ({ receipt_path, id }) => ({ receipt_path, id }),
                  maxWidth: 100,
                  Cell: ({ value: { receipt_path, id } }) => (
                    <Actions>
                      <ContextMenu
                        value={2}
                        elements={[
                          {
                            id: 1,
                            icon: 'arrowRight',
                            label: 'Mostrar',
                            onClick: () => window.open(receipt_path),
                          },
                          {
                            id: 2,
                            icon: 'remove',
                            label: 'Borrar',
                            onClick: () => this.confirmDeleteCharge(id, 'pago'),
                          },
                        ]}
                      />
                    </Actions>
                  ),
                },
              ]}
            />
          </TableContainer>
        )}
        <AddDepositModal
          onClose={this.closeDeposit}
          open={this.state.addDepositOpen}
          company={company}
          sending={sending}
          paymentTypes={paymentTypes}
          sendDeposit={createPayment}
          country={country}
        />
        <ConfirmDeleteChargeModal
          chargeId={chargeId}
          handleSubmit={this.handleDelete}
          isOpen={isConfirmDeleteChargeModalOpen}
          loading={isDeleting}
          onClose={this.closeDeleteChargeModal}
          typeToDelete={typeToDelete}
        />
      </Container>
    )
  }
}

CompanyAccount.propTypes = {
  /** The ID of the active company */
  company: PropTypes.object.isRequired,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  getCompanyAccount: PropTypes.func.isRequired,
  createPayment: PropTypes.func.isRequired,
}

CompanyAccount.defaultProps = {
  loading: false,
  balance: {},
}

const mapStateToProps = ({ companyAccount, ...state }) => ({
  balance: companyAccount.get.results.data,
  loading: companyAccount.get.fetching,
  sending: companyAccount.create.fetching,
  isDeleting: companyAccount.delete.fetching,
  meta: companyAccount.get.results.meta,
  country: state.countries.get.results[0],
  paymentTypes: state.companies.paymentsTypes.result,
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const companyId = parseInt(ownProps.match.params.id, 10)
  return {
    getCompanyAccount: (companyId, page) => dispatch(CompanyAccountActions.getRequest({ companyId, page })),
    createPayment: (companyId, payment) =>
      dispatch(CompanyAccountActions.createPaymentRequest(companyId, payment)),
    deletePayment: payment =>
      dispatch(CompanyAccountActions.deletePaymentRequest(companyId, payment)),
    goTo: path => dispatch(push(path)),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyAccount))



// WEBPACK FOOTER //
// ./src/Containers/CompanyAccount/CompanyAccount.jsx